import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FleetInspection, FleetInspectionField, FleetInspectionFields } from 'src/app/models/fleetinspection';
// import { FleetInspect, FleetInspectCheck, FleetInspectField, FleetInspectFields, FleetInspection } from 'src/app/models/fleetauth';
import { ReportBase64 } from 'src/app/models/reports';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})

export class FleetInspectionService {
    apiUrl = 'v1/fleetinspection/';

    constructor(private http: HttpClient) { }

    public getFleetInspectionData(specialPriceSetId: number) {
        return this.http.get<FleetInspectionField[]>(environment.ApiUrl() + this.apiUrl + specialPriceSetId);
    }

    public setFleetInspectionData(specialPriceSetId: number) {
        return this.http.post(environment.ApiUrl() + this.apiUrl + 'setFleetInspection/' + specialPriceSetId, null);
    }

    public saveFleetInspectFields(specialPriceSetId: number, fleetInspectionFieldId: number, body: FleetInspectionField) {
        return this.http.post(environment.ApiUrl() + this.apiUrl + `setFleetInspectionFieldValue/${specialPriceSetId}/${fleetInspectionFieldId}`, body);
    } 

    public saveFleetInspection(specialPriceSetId: number, fleetInspectionFieldId: number, body: FleetInspectionFields) {
        return this.http.post<FleetInspectionFields>(environment.ApiUrl() + this.apiUrl + `setFleetInspectionFieldValue/${specialPriceSetId}/${fleetInspectionFieldId}`, body);
    } 

    public emailFleetInspection(fleetInspectionId: number, emailTo: string) {
        return this.http.post(environment.ApiUrl() + this.apiUrl + `emailFleetInspection/${fleetInspectionId}/${emailTo}`, null);
    }
}